import { api } from "./api";
import { convertToCamel } from "@lib/convertToCamel";
import { FeedPost } from "@dto/FeedPost";
import { ListEntitiesRequest } from "@store/apiTypes";

export const feedPostApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getFeedPost: build.query<FeedPost, string | number>({
      query: (idOrSlug) => {
        return { url: `/feed_posts/${idOrSlug}` };
      },
      transformResponse: (responseData) => {
        const feedPost = convertToCamel(responseData) as any;
        feedPost.type = "FeedPost";
        feedPost.coverPhotoUrl = feedPost.imageUrl;
        feedPost.name = feedPost.text;
        return feedPost as FeedPost;
      },
      providesTags: (_feedPost, _err, id) => [{ type: "FeedPost", id }],
    }),
    listFeedPosts: build.query<FeedPost[], ListEntitiesRequest>({
      query: (request) => {
        const queryParams = [`page=${request.page}`];

        const url = `/feed_posts?${queryParams.join("&")}`;

        return { url: url };
      },
      transformResponse: (responseData) => {
        const result = convertToCamel(responseData) as FeedPost[];
        result.forEach((feedPost) => {
          feedPost.coverPhotoUrl = feedPost.imageUrl;
          feedPost.name = feedPost.text;
          feedPost.type = "FeedPost";
        });
        return result;
      },
    }),
  }),
});

export const { useGetFeedPostQuery } = feedPostApi;

export const {
  endpoints: { listFeedPosts },
} = feedPostApi;
